import { useMemo } from "react"

import { defaultRemarkPlugins, type StreamdownProps } from "streamdown"

import { linkifyCoviEntitiesPlugin } from "../utils/entityLinks"

/** Keeps Streamdown's defaults while appending Sofia's scoped entity linkifier. */
export function useCoviEntityLinkPlugins(
  organizationSlug: string | null,
  workspaceSlug: string | null,
) {
  return useMemo<NonNullable<StreamdownProps["remarkPlugins"]>>(
    () => [
      ...Object.values(defaultRemarkPlugins),
      // Streamdown caches processors by plugin name and serialized options, so scope cannot live only in a closure.
      [linkifyCoviEntitiesPlugin, { organizationSlug, workspaceSlug }],
    ],
    [organizationSlug, workspaceSlug],
  )
}
